import { Device } from "../../lib/Device";
import { Home as HomeType } from "../../lib/Home";

function matches(value: unknown, query: string): boolean {
  if (value == null) return false;
  return String(value).toLowerCase().includes(query);
}

function homeMatches(home: HomeType, query: string): boolean {
  const fullName = `${home.user_first_name ?? ""} ${home.user_last_name ?? ""}`.trim();

  return [
    home.name,
    home.user_email,
    home.user_first_name,
    home.user_last_name,
    fullName,
  ].some((field) => matches(field, query));
}

function devicesMatch(devices: Device[] | null, homeId: number, query: string): boolean {
  if (!devices?.length) return false;

  return devices.some((d) => {
    if (d.home !== homeId) return false;

    return (
      matches(d.id, query) ||
      matches(d.device_id, query) ||
      matches(d.name, query) ||
      matches(d.soliseco_model, query)
    );
  });
}

export function homeMatchesSearchQuery(
  home: HomeType,
  devices: Device[] | null,
  query: string
): boolean {
  const q = query.toLowerCase().trim();
  if (!q) return true;

  return homeMatches(home, q) || devicesMatch(devices, home.id, q);
}